<template>
  <!-- <div> -->
  <v-toolbar-items class="d-md-none">
    <v-menu right bottom :offset-y="true">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon>
          <v-icon>mdi-settings</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="setUp('GEN', 'General Setup')">
          <v-list-item-title>General</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setUp('PI', 'Personal Information')">
          <v-list-item-title>Personal Information</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setUp('EI', 'Employment Information')">
          <v-list-item-title>Employment Information</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setUp('EOI', 'Employment Other Information')">
          <v-list-item-title>Employment Other Information</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu right bottom :offset-y="true">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon>
          <v-icon>mdi-wrench</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="setUp('EMF', 'Employee Master File')">
          <v-list-item-title>Employee Master File</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setUp('EOIM', 'Employee Other Information')">
          <v-list-item-title>Employee Other Information</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- <v-btn icon @click="setUp('MAINT', 'Maintenance')">
      <v-icon>mdi-wrench</v-icon>
    </v-btn>-->

    <v-menu right bottom :offset-y="true">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon>
          <v-icon>mdi-file-document-box</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="setUp('PMT', 'Personnel Movement')">
          <v-list-item-title>Personnel Movement</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setUp('MPT', 'Manpower Pool')">
          <v-list-item-title>Manpower Pool</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setUp('PRT', 'Personnel Requisition')">
          <v-list-item-title>Personnel Requisition</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setUp('ECT', 'Employee Clearance')">
          <v-list-item-title>Employee Clearance</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn icon @click="setUp('UTILS', 'Utilities')">
      <v-icon>mdi-water-boiler</v-icon>
    </v-btn>
    <!-- <v-btn icon @click="setUp('REP', 'Reports')">
      <v-icon>mdi-printer</v-icon>
    </v-btn>-->
    <v-btn icon to="/reports">
      <v-icon>mdi-printer</v-icon>
    </v-btn>
    <v-btn icon @click="admin">
      <v-icon>mdi-account-box</v-icon>
    </v-btn>
    <slot></slot>
    <!-- Small Screen -->
  </v-toolbar-items>

  <!-- </div> -->
</template>
<script>
import { mapActions } from "vuex";
import AdminMenuItems from "../utils/adminMenu";
export default {
  data: () => ({
    adminMenuItems: AdminMenuItems
  }),
  methods: {
    ...mapActions("appRouting", ["changeRoute", "openDrawer"]),
    admin() {
      this.changeRoute(this.adminMenuItems);
      this.openDrawer(true);
    },
    setUp(value, name) {
      this.changeRoute({ routeName: name, routeValue: value });
      this.openDrawer(true);
    }
  }
};
</script>